import { trigger, state, style, transition, animate } from '@angular/animations';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-support-collab-chat-header',
  templateUrl: './support-collab-chat-header.component.html',
  styleUrls: ['./support-collab-chat-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkAccordionItem, CommonModule, SvgIconComponent, TranslateModule],
  animations: [
    trigger('slideToggle', [
      state('collapsed', style({ height: '0px', display: 'none', scale: 0 })),
      state('expanded', style({ height: '*', display: 'grid', scale: 1 })),
      transition('collapsed => expanded', [
        style({ height: '0px', display: 'grid', transformOrigin: 'top right', scale: 0 }),
        animate('300ms ease-in-out', style({ height: '*', display: 'grid', scale: 1 })),
      ]),
      transition('expanded => collapsed', [
        style({ height: '*', display: 'grid', transformOrigin: 'top right', scale: 1 }),
        animate('300ms ease-in-out', style({ height: '0px', display: 'none', scale: 0 })),
      ]),
    ]),
  ],
})
export class SupportCollabChatHeaderComponent {
  @Input() public expanded = true;

  protected bookTimeUrl =
    'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1IoOcfQ_W8JEW72mzlC5Hd-47o6GwjWtyLe3C-sXvSoAnADzviKgS-hSvEQeiyWE9amg4UOt-4';
}
